import { cn } from '@/lib/cn';

import { Tooltip } from './Tooltip';

/**
 * H1 (rodada AJUDA-UX-QA) — Ajuda contextual reutilizável: o "?" padrão.
 *
 * FASE-C: o balão migrou pro `<Tooltip>` canônico (portal + flip/shift) — o
 * balão NUNCA mais é cortado por card/tabela com overflow nem estoura a
 * viewport na borda. A API pública (texto/lado/className) não mudou: todos os
 * "?" do sistema migraram juntos.
 *
 * Uso:
 *   <span className="inline-flex items-center gap-1">
 *     Régua de margem <HelpTip texto="Define as faixas que pintam a margem." />
 *   </span>
 *
 * Regras de copy (handoff): pt-BR simples, sem jargão, explica O QUE a função
 * faz / a que se refere — não como implementada.
 */
export function HelpTip({
  texto,
  lado = 'cima',
  className,
}: {
  texto: string;
  /** Preferência de abertura — o flip automático inverte se faltar espaço. */
  lado?: 'cima' | 'baixo';
  className?: string;
}) {
  return (
    <Tooltip content={texto} lado={lado}>
      <button
        type="button"
        aria-label="Ajuda"
        className={cn(
          'inline-flex items-center justify-center shrink-0 w-4 h-4 rounded-full',
          // ── Alvo de toque (auditoria do Financeiro, 01/08: medido 16px no
          // mobile, contra o piso de 44 que o próprio sistema adota).
          //
          // O círculo NÃO cresce de propósito: este é um afixo inline colado a
          // um rótulo — 44px visíveis desalinhariam o texto em toda tela que o
          // usa. O que cresce é só a ÁREA CLICÁVEL, via pseudo-elemento
          // absoluto, que não ocupa espaço no fluxo e portanto não mexe em
          // layout nenhum.
          //
          // `relative` é o que ancora o `::before`; sem ele o inset vaza pro
          // ancestral posicionado mais próximo e o alvo aparece no lugar errado.
          'relative before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2',
          'before:w-11 before:h-11 before:content-[""]',
          'text-xs font-bold leading-none select-none cursor-help align-middle',
          'bg-line dark:bg-line-dark text-ink-3 dark:text-ink-dark-3',
          'hover:bg-red-soft hover:text-red dark:hover:bg-red-soft-dark',
          'focus-visible:bg-red-soft focus-visible:text-red',
          'transition-colors',
          className,
        )}
      >
        ?
      </button>
    </Tooltip>
  );
}
